module.exports = __webpack_public_path__ + "static/media/dico2.2ee381e1.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/parcours/dico2.JPG
// module id = 147
// module chunks = 0